<div class="card border-primary mb-3">
    <div class="card-body">
        <h2 class="h6 mt-0">Pay for your permit</h2>

        @if (loading) {
            <ngxh6-loading-or-error></ngxh6-loading-or-error>
        } @else {
            @if (amount) {
                <p class="mb-3">
                    Amount due: <strong>{{ amount | currency: 'AUD' : '$' }}</strong>
                    <span class="d-block small text-muted">Your permit is issued as soon as your payment is received.</span>
                </p>
            }

            <!-- Stripe mounts its card + billing fields here. -->
            <div id="permit-card-element" class="mb-3"></div>

            @if (error) {
                <div class="alert alert-danger" role="alert">{{ error }}</div>
            }

            <button type="button" class="btn btn-primary ms-0" (click)="pay()" [disabled]="!ready || processing">
                {{ processing ? 'Processing…' : 'Pay ' + (amount | currency: 'AUD' : '$') }}
            </button>
        }
    </div>
</div>
